import { render, staticRenderFns } from "./ClientPersonalInfoPopUp.vue?vue&type=template&id=574a86e0&scoped=true&"
import script from "./ClientPersonalInfoPopUp.vue?vue&type=script&lang=js&"
export * from "./ClientPersonalInfoPopUp.vue?vue&type=script&lang=js&"
import style0 from "./ClientPersonalInfoPopUp.vue?vue&type=style&index=0&id=574a86e0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../safari-rental/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "574a86e0",
  null
  
)

export default component.exports